import { HttpClient } from '@angular/common/http';
import { Injectable, Injector } from '@angular/core';
import { BaseService, EnvironmentService } from 'tnx-shared';

@Injectable({
    providedIn: 'root'
})
export class RoleService extends BaseService {
    entityName = 'Role';
    serviceCode = 'Authorization';

    constructor(http: HttpClient, injector: Injector,
                private _environmentService: EnvironmentService) {
        super(http, injector, ``);
        this.endPoint = _environmentService.getHttpServiceEndpointWithVersion(this.serviceCode);
                this.serviceUri = `${this.endPoint}/${this.entityName}`;
    }

    getDetailCustom(id: string, pid: string) {
        const url = `${this.serviceUri}/GetDetailCustom/${id}?pid=${pid}`;
        return this.defaultGet(url);
    }

    GetIdByUsers(model) {
        const url = `${this.serviceUri}/GetIdByUsers`;
        return this.defaultPost(url, model);
    }

    GetIdByGroupUsers(model) {
        const url = `${this.serviceUri}/GetIdByGroupUsers`;
        return this.defaultPost(url, model);
    }

    GetIntersectIdByGroupUsers(userIds) {
        const url = `${this.serviceUri}/GetIntersectIdByGroupUsers`;
        return this.defaultPost(url, userIds);
    }

    GetIntersectDirectIdByGroupUsers(userIds) {
        const url = `${this.serviceUri}/GetIntersectDirectIdByGroupUsers`;
        return this.defaultPost(url, userIds);
    }

    GetIntersectIdByUsers(userIds) {
        const url = `${this.serviceUri}/GetIntersectIdByUsers`;
        return this.defaultPost(url, userIds);
    }

    GetIntersectDirectIdByUsers(userIds) {
        const url = `${this.serviceUri}/GetIntersectDirectIdByUsers`;
        return this.defaultPost(url, userIds);
    }

}
